import { Box, Button, Typography } from '@material-ui/core';
import React from 'react';
import * as Api from './api';
import InputCpf, { validaCpf } from './InputCpf';
import queryString from 'query-string';

export const onEnter = (callback) => (e) => {
    if (e.key === 'Enter' || e.which === 13 || e.keyCode === 13) {
        callback(e);
    }
};

const ConsultaAssinante = ({ onConsultarAssinante }) => {
    const [helpText, setHelpText] = React.useState();
    const params = queryString.parse(window.location.search);
    const [cpf, setCpf] = React.useState(
        params.cpf || process.env.REACT_APP_DEFAULT_CPF,
    );

    const consultarAssinante = () => {
        if (!validaCpf(cpf)) {
            setHelpText('Número do CPF não é válido');
            return;
        }
        Api.consultarAssinante(cpf).then((assinante) => {
            if (assinante && assinante.perfil) onConsultarAssinante(assinante);
            else setHelpText('Assinante não cadastrado !');
        });
    };

    React.useEffect(() => {
        setHelpText(undefined);
        if (validaCpf(cpf)) {
            consultarAssinante();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cpf]);

    return (
        <Box
            style={{
                display: 'flex',
                minHeight: '90vh',
                flexDirection: 'column',
                justifyContent: 'space-around',
            }}
        >
            <Typography variant="h5">Assinante</Typography>
            <InputCpf
                type="CPF"
                label="CPF"
                value={cpf}
                onValueChange={({ value }) => setCpf(value)}
                helperText={helpText}
                error={!!helpText}
                onKeyDown={onEnter(consultarAssinante)}
            />
            <Button onClick={consultarAssinante} style={{ margin: '10% 0px' }}>
                OK
            </Button>
        </Box>
    );
};

ConsultaAssinante.defaultProps = {
    onConsultarAssinante: console.warn,
};

export default ConsultaAssinante;
